import SENECA_HAVEN_MOBS from "./haven";
import SENECA_MERIDIAN_MOBS from "./meridian";
import SENECA_UNDERHAVEN_MOBS from "./underhaven";

const SENECA_MOBS = {
  ...SENECA_HAVEN_MOBS,
  ...SENECA_UNDERHAVEN_MOBS,
  ...SENECA_MERIDIAN_MOBS,
};

export default SENECA_MOBS;
